import { useState, useEffect, useCallback } from "react";
import { fetchAllProjects } from "../../services/allProjects.service";
import { useHistory } from "react-router-dom";

const useAllProjects = (status, search, boolSearch, tabKey, routes) => {
  const [projects, setProjects] = useState([]);
  const [pagination, setPagination] = useState({
    totalCount: 0,
    currentPage: 1,
    totalPages: 0,
    pageSize: 10,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const history = useHistory();

  const loadProjects = useCallback(
    async (page = 1) => {
      if (tabKey !== "draftprojects") {
        setIsLoading(true);
        setError(null);

        try {
          const data = await fetchAllProjects(
            page,
            pagination.pageSize,
            status,
            search
          );
          setProjects(data.data.projects);
          setPagination({
            totalCount: data.data.count,
            currentPage: page,
            totalPages: data.data.pages,
            pageSize: pagination.pageSize,
          });
        } catch (error) {
          console.error("Failed to fetch projects:", error);
          setError(error.response?.data?.message || "Failed to fetch projects");
          history.push("/login");
        } finally {
          setIsLoading(false);
        }
      }
    },
    [pagination.pageSize, status, search, boolSearch, tabKey]
  );

  const handlePageChange = useCallback(
    (page) => {
      loadProjects(page);
    },
    [loadProjects]
  );

  useEffect(() => {
    loadProjects(1);
  }, [status, boolSearch, tabKey, routes]);

  return {
    projects,
    pagination,
    isLoading,
    error,
    handlePageChange,
    loadProjects,
  };
};

export default useAllProjects;
